import { Info, MapPinLine, Users } from '@phosphor-icons/react';
import endpoints from 'endpoints';
import urljoin from 'url-join';
import { formatDateToDayMonthYear } from 'utils/format-date';
import { formatTime } from 'utils/format-time';
import { getPlaceholderPhoto } from 'utils/get-placeholder-photo';

import { useGetBuilding } from 'api/get-building';
import { CalendarEventData } from 'api/get-calendar-events';

import { getOverflowScrollStyle, useOverflowScroll } from 'hooks/use-overflow-scroll';

import * as S from './calendar-event.styled';

interface CalendarEventProps {
  data: CalendarEventData;
}

export const CalendarEvent = ({ data }: CalendarEventProps) => {
  const { data: building } = useGetBuilding();
  const title = useOverflowScroll(data.name);
  const description = useOverflowScroll(data.description, 'vertical');

  return (
    <S.Container>
      <S.ImageContainer>
        <S.Image
          src={
            data.image
              ? urljoin(process.env.REACT_APP_EV_URL, endpoints.EVENT_IMAGE, data.image)
              : getPlaceholderPhoto()
          }
        />
      </S.ImageContainer>
      <S.InfoContainer>
        <S.TopRow>
          <S.Title ref={title.containerRef} $isScrolling={!!title.scroll}>
            <S.TitleText ref={title.textRef} $isScrolling={!!title.scroll} style={getOverflowScrollStyle(title.scroll)}>
              {data.name}
            </S.TitleText>
          </S.Title>
          <S.Date>
            {formatDateToDayMonthYear(new Date(data.date), building?.timezone)} <S.DateDivider />{' '}
            {formatTime(data.date)}
          </S.Date>
        </S.TopRow>
        <S.BottomRow>
          <S.IconValueContainer $gridArea="location">
            <MapPinLine />
            <span>Location: {data.place}</span>
          </S.IconValueContainer>
          <S.IconValueContainer $gridArea="capacity">
            <Users />
            <span>Capacity: {data.capacity}</span>
          </S.IconValueContainer>
          <S.IconValueContainer $gridArea="description" $multiline>
            <Info />
            <S.Description ref={description.containerRef}>
              <S.DescriptionText
                ref={description.textRef}
                $isScrolling={!!description.scroll}
                style={getOverflowScrollStyle(description.scroll)}
              >
                {data.description}
              </S.DescriptionText>
            </S.Description>
          </S.IconValueContainer>
        </S.BottomRow>
      </S.InfoContainer>
    </S.Container>
  );
};
